import { PeopleTypeData, TotalsPerDay } from "../statistics.model";

export interface PeopleDataResponse {
  totalMen: number;
  totalWomen: number;
  totalOts: number;
  targetGroups: PeopleTargetGroup[];
}
export interface PeopleTargetGroup {
  targetGroup: number;
  count: number;
}

export interface ScreenHour {
  screenId: number;
  peoples: PeopleTargetGroup[];
  time: string; 
  opportunityToSee: number;
}

export interface PeopleCounterResponse {
  screenHours: ScreenHour[]; //PeopleCounterDailySummaryItem
  currentPage: number;
  totalPages: number;
  pageSize: number;
  totalCount: number;
  hasPrevious: boolean;
  hasNext: boolean;
}

export enum GenderEnum {
  Male = 1,
  Female = 2,
}

export enum VehicleType {
  Car = 0,
  Van = 1,
  Bus = 2,
  Truck = 3
}

export interface VehicleTypeResponse extends VehicleTypeData {
  averageVehiclesPerHour: AverageReachItemsPerHour[];
}

export interface PeopleTypeResponse extends PeopleTypeData {
  averagePeoplePerHour: AverageReachItemsPerHour[];
}

export interface VehicleTypeData {
  cars: number;
  vans: number;
  busses: number;
  trucks: number;
  opportunityToSee?: number;
  total: number;
  hours?: string[];
}

export interface FormatedVehicleDistribution {
  hours: string[];
  total: number[];
  cars: number[];
  busses: number[];
  trucks: number[];
  vans: number[];
}

export interface VehicleTypeDataFormated {
  value: number;
  type: VehicleTypes;
  color: string;
  label: string;
}

export interface AverageReachItemsPerHour {
  hour: number;
  average: number;
  averageItems: (VehicleTypeItem | PeopleTypeItem) [];
}

export interface PeopleTypeItem {
  gender: GenderEnum;
  count: number;
}

export interface VehicleTypeItem {
  vehicleType: VehicleType;
  count: number;
}

export interface InitialData {
  type: VehicleTypes | PeopleTypes;
  label: string;
  value: number;
}

export enum VehicleTypes {
  Total = 'total',
  Cars = 'cars',
  Vans = 'vans',
  Busses = 'busses',
  Trucks = 'trucks',
  OpportunityToSee = 'opportunityToSee',
}


export enum PeopleTypes {
  Total = 'total',
  Men = 'totalMen',
  Women = 'totalWomen',
  Ots = 'totalOts',
}
